/**
 * グループ契約設定ページ用のスクリプト
 */
if (is_route('holding_contract.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        holding_contract_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.holding_contract_event_set = function() {

    let setItpSetting = function(isItpLinkage) {
        let useStartedAt = $('input[name="use_started_at"]');
        let userName = $('input[name="user_name"]');
        let password = $('input[name="password"]');
        let clientId = $('input[name="client_id"]');
        let clientSecret = $('input[name="client_secret"]');
        if (isItpLinkage === '0') {
            useStartedAt.val('').prop('disabled', true).parent('div').prev('.badge-required').addClass('d-none');
            userName.val('').prop('disabled', true).prev('.badge-required').addClass('d-none');
            password.val('').prop('disabled', true).parent('div').prev('.badge-required').addClass('d-none');
            clientId.val('').prop('disabled', true).prev('.badge-required').addClass('d-none');
            clientSecret.val('').prop('disabled', true).prev('.badge-required').addClass('d-none');
            $('.errors span:visible').html('');
        } else {
            useStartedAt.prop('disabled', false).parent('div').prev('.badge-required').removeClass('d-none');
            userName.prop('disabled', false).prev('.badge-required').removeClass('d-none');
            password.prop('disabled', false).parent('div').prev('.badge-required').removeClass('d-none');
            clientId.prop('disabled', false).prev('.badge-required').removeClass('d-none');
            clientSecret.prop('disabled', false).prev('.badge-required').removeClass('d-none');
        }
    }

    /*---- 設定表示時 ----*/

    //設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id'], true, function() {
            setItpSetting($('input[name="is_itp_linkage"]:checked').val());
            $('input[name="is_itp_linkage"]').off().on('change', function(){
                setItpSetting($(this).val());
            });
        });
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal', null, function() {
            // エラータブにエラースタイル適用
            if ($('#base .errors .invalid-feedback').not('.copy').length > 0) {
                $('#base-tab').parent('.nav-item').addClass('error');
            } else {
                $('#base-tab').parent('.nav-item').removeClass('error');
            }
            if ($('#itp .errors .invalid-feedback').not('.copy').length > 0) {
                $('#itp-tab').parent('.nav-item').addClass('error');
            } else {
                $('#itp-tab').parent('.nav-item').removeClass('error');
            }
        });
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });
}
